import styled from 'styled-components';
import { trashCircle } from '../../assets';

export const ModalContent = styled.div`
  width: 586px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 60px;
  border-radius: 6px;
  background-color: ${props => props.theme.colors.white};
`;

export const ModalIcon = styled.img.attrs({
  src: trashCircle
})`
  height: 60px;
  width: 60px;
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h3`
  color: ${props => props.theme.colors.red};
  font-weight: 500;
  font-size: 28px;

  margin-bottom: 12px;
`;

export const ModalSubtitle = styled.p<{ bold?: boolean }>`
  font-size: 16px;
  line-height: 21px;
  font-weight: ${props => (props.bold ? 600 : 'normal')};
  text-align: center;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  padding: 0 32px;
`;

export const ModalButtonOutlined = styled.button`
  height: 42px;
  width: 48%;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.red};
  border: none;

  &:hover {
    background-color: ${props => props.theme.colors.danger};
    transition: background-color 200ms linear;
  }
`;

export const ModalButton = styled.button`
  height: 42px;
  width: 48%;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: ${props => props.theme.colors.white};
  background: linear-gradient(90deg, #f83600, #fe8c00);
  border: none;

  &:hover {
    background: linear-gradient(90deg, #e53c0d, #e53c0d);
    transition: background-color 200ms linear;
  }
`;
